import React, {Component} from 'react';

import SpecialPricingForm from '../../../shared/components/SpecialPricingForm';

import ProgressEllipses from '../../../shared/components/ProgressEllipses';

class BrandSpecialPricing extends Component {
  constructor(){
    super();

    this.state = {
      updating:false,
      loading:true,
      error:null
    };
  }

  componentWillMount(){
    Promise.all([
      this.props.loadAgency(this.props.agencyId),
      this.props.loadBrand(this.props.brandId)
    ])
      .then(() => this.setState({loading:false}))
  }

  handleSubmit(data){
    this.setState({updating:true});

    if(data.useCostPerCompletion){
      this.props.updateBrand(this.props.brandId,{
        useCostPerCompletion:true,
        defaultRevenueSplit:data.revenueSplit,
        defaultCostPerCompletion:data.defaultCostPerCompletion
      })
        .then(() => this.setState({updating:false}))
       .catch((err) => this.setState({error:err}));

    } else {
      this.props.updateBrand(this.props.brandId,{
        useCostPerCompletion:false,
        chooseDefaultCost:data.chooseDefaultCost,
        defaultRevenueSplit:data.revenueSplit,
        ratableDefaultCost:data.ratableDefaultCost,
        qaDefaultCost:data.qaDefaultCost,
        puzzleDefaultCost:data.puzzleDefaultCost,
        thisOrThatDefaultCost:data.thisOrThatDefaultCost
      })
        .then(() => this.setState({updating:false}))
        .catch((err) => this.setState({error:err}));
    }
  }

  render(){
    const {
      defaultRevenueSplit,
      defaultDefaultRevenueSplit,
      chooseDefaultCost,
      defaultChooseDefaultCost,
      thisOrThatDefaultCost,
      defaultThisOrThatDefaultCost,
      ratableDefaultCost,
      qaDefaultCost,
      defaultQADefaultCost,
      puzzleDefaultCost,
      defaultPuzzleDefaultCost,
      defaultRatableDefaultCost,
      defaultCostPerCompletion,
      useCostPerCompletion
    } = this.props;

    const { updating,loading } = this.state;



    return loading ? (
      <div>Loading...</div>
    ) : (
      <SpecialPricingForm
        forceUpdate
        updateButtonText={updating ? 'Updating Brand':'Update Brand'}
        defaultRevenueSplit={defaultRevenueSplit}
        defaultDefaultRevenueSplit={defaultDefaultRevenueSplit}
        chooseDefaultCost={chooseDefaultCost}
        defaultChooseDefaultCost={defaultChooseDefaultCost}
        thisOrThatDefaultCost={thisOrThatDefaultCost}
        defaultThisOrThatDefaultCost={defaultThisOrThatDefaultCost}
        ratableDefaultCost={ratableDefaultCost}
        defaultRatableDefaultCost={defaultRatableDefaultCost}
        qaDefaultCost={qaDefaultCost}
        defaultQADefaultCost={defaultQADefaultCost}
        puzzleDefaultCost={puzzleDefaultCost}
        defaultPuzzleDefaultCost={defaultPuzzleDefaultCost}
        defaultCostPerCompletion={defaultCostPerCompletion}
        useCostPerCompletion={useCostPerCompletion}
        onSubmit={(data) => this.handleSubmit(data)}
      />
    )
  }
}

export default BrandSpecialPricing;



// WEBPACK FOOTER //
// ./src/routes/BrandSpecialPricing/components/BrandSpecialPricing.js